import { object, string } from 'yup';

import 'web-shared/config/yup-config';
import { LoginURLState } from 'web-shared/services/sso-auth-service/SSOService';
import { getFormFieldNameGenerator } from 'web-shared/utils/form';

export interface AuthLocationState {
  from?: LoginURLState['from'];
  showPasswordResetSuccess?: boolean;
}

export interface SignInFormValues {
  email: string;
  password: string;
}

export const signInFieldNameGenerator = getFormFieldNameGenerator<SignInFormValues>();

export const initialValues: SignInFormValues = {
  email: '',
  password: '',
};

export const validationSchema = object().typedShape<SignInFormValues>({
  email: string().email('emailIsInvalid').required(),
  password: string().required(),
});
